const CRAWLER_USER_AGENT_PATTERN = /bot|crawl|spider|slurp|mediapartners|facebookexternalhit|whatsapp|telegrambot|preview|headless/iu;

/**
 * Detects whether the current page is being rendered by a search engine crawler or other
 * automated fetcher (e.g. Googlebot, Bingbot, social media link-preview bots) rather than a
 * real user's browser, based on the user agent string.
 *
 * @returns `true` when the user agent matches a known crawler/bot pattern.
 */
export const isCrawler = (): boolean => {
    if (typeof navigator === 'undefined') return false;

    return CRAWLER_USER_AGENT_PATTERN.test(navigator.userAgent);
};